import * as React from "react";
const XCorpSmall = ({ size, ...props }) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 18 18", fill: "currentColor", width: size || "18", height: size || "18", ...props }, /* @__PURE__ */ React.createElement("path", { d: "m4.027 4 4.247 5.516L4 14h.962l3.742-3.926L11.727 14H15l-4.486-5.826L14.492 4h-.962l-3.446 3.616L7.3 4H4.027Zm1.414.688h1.504l6.64 8.624h-1.503l-6.64-8.624Z" }));
XCorpSmall.displayName = "XCorpSmall";
var XCorpSmall_default = XCorpSmall;
export {
  XCorpSmall_default as default
};
